import { Link, useNavigate } from "react-router-dom";
import { admin_permission, getApiDomain } from "../../config";
import { signOut } from "supertokens-auth-react/recipe/session";
import HasPermission from "../../claims/SessionClaims";
import { EmailImage, LogoARASAAC, LogoCNSE } from "../../assets/images";
import CookiesModal from "../CookiesModal/CookiesModal";

export default function Info() {
    const navigate = useNavigate();

    async function handleLogout() {
        await signOut();
        navigate("/auth");
    }

    function openLink(url: string) {
        window.open(url, "_blank");
    }

    return <div className="component-container container-big">
        <div className="d-flex flex-column">
            <div className="d-flex flex-wrap items-center justify-content-center">
                <div className="d-flex flex-column w-md-33">
                    <a className='d-flex' onClick={(e) => {e.preventDefault(); openLink("mailto:qb.pablo.2000@gmail.com")}}>
                        <img src={EmailImage} width='120' alt="Email" />
                    </a>
                </div>
                <div className="d-flex flex-column w-md-66">
                    <div className="text-justify">Nos encanta recibir cualquier idea, sugerencia o queja: <a onClick={(e) => {e.preventDefault(); openLink("mailto:qb.pablo.2000@gmail.com")}}>qb.pablo.2000@gmail.com</a></div>
                </div>
            </div>
            <div className="d-flex flex-wrap items-center justify-content-center mb-2">
                <div className="d-flex flex-column w-md-33 mt-4 mb-3">
                <a className='d-flex' href="https://www.arasaac.org" target="_blank" rel="noreferrer">
                    <img src={LogoARASAAC} width='160' alt="Logo ARASAAC" />
                </a>
                <a className='d-md-flex d-none' href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank" rel="noreferrer">
                    <img src='https://mirrors.creativecommons.org/presskit/buttons/88x31/svg/by-nc-sa.svg' width='100' className='mt-3' alt="By-NC-SA" />
                </a>
                </div>
                <div className="d-flex flex-column w-md-66">
                    <div className="text-justify">Algunos de los vídeos en LSE utilizados son propiedad del Gobierno de Aragón y han sido creados por ASZA para ARASAAC (<a href="https://www.arasaac.org" target="_blank" rel="noreferrer">www.arasaac.org</a>), que los distribuye bajo Licencia Creative Commons BY-NC-SA</div>
                    <a className='d-md-none d-flex' href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank" rel="noreferrer">
                        <img src='https://mirrors.creativecommons.org/presskit/buttons/88x31/svg/by-nc-sa.svg' width='100' className='mt-3' alt="By-NC-SA" />
                    </a>
                </div>
            </div>
            <div className="d-flex flex-wrap items-center justify-content-center mb-2">
                <div className="d-flex flex-column w-md-33 mt-4 mb-3">
                <a className='d-flex' href="https://www.arasaac.org" target="_blank" rel="noreferrer">
                    <img src={LogoCNSE} width='160' alt="Logo ARASAAC" />
                </a>
                <a className='d-md-flex d-none' href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank" rel="noreferrer">
                    <img src='https://mirrors.creativecommons.org/presskit/buttons/88x31/svg/by-nc-sa.svg' width='100' className='mt-3' alt="By-NC-SA" />
                </a>
                </div>
                <div className="d-flex flex-column w-md-66">
                    <div className="text-justify">Otros de los vídeos en LSE utilizados son propiedad de la FUNDACIÓN CNSE PARA LA SUPRESIÓN DE BARRERAS DE LA COMUNICACIÓN (<a href="https://www.fundacioncnse.org/" target="_blank" rel="noreferrer">www.fundacioncnse.org</a>), que los distribuye bajo Licencia Creative Commons BY-NC-SA</div>
                    <a className='d-md-none d-flex' href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank" rel="noreferrer">
                        <img src='https://mirrors.creativecommons.org/presskit/buttons/88x31/svg/by-nc-sa.svg' width='100' className='mt-3' alt="By-NC-SA" />
                    </a>
                </div>
            </div>
            <div className="text-justify mute"><i>ALSE está diseñada para apoyar la memorización de la LSE. No pretende, bajo ninguna circunstancia, sustituir las imprescindible práctica directa. Tampoco aborda aspectos fundamentales como la gramática ni las estructuras lingüísticas de la LSE.</i></div>
            <h3 className="text-left w-100 mb-3">Papeleos y cosas legales 📋✒️</h3>
            <div className="text-justify">
                <div className="mb-3">
                    <h4 className="d-inline"><Link to='/politica-de-privacidad'>🔒 Política de privacidad</Link></h4>: 
                    Conoce cómo protegemos tu información personal y garantizamos tu privacidad al usar nuestra aplicación.
                </div>
                <div className="mb-3">
                    <h4 className="d-inline"><Link to='/politica-de-cookies'>🍪 Política de cookies</Link></h4>: 
                    Descubre qué son las cookies, por qué las usamos y cómo puedes gestionarlas en nuestra app.
                </div>
                <div className="mb-3">
                    <h4 className="d-inline"><Link to='/aviso-legal'>⚖️ Aviso legal</Link></h4>: 
                    Toda la información que necesitas sobre el uso, derechos y responsabilidades al acceder a nuestra aplicación.
                </div>
            </div>
            <button className='btn w-50 error px-4' onClick={() => handleLogout()}>Cerrar sesión</button>
            {
                HasPermission(admin_permission) &&
                <button className='btn w-50' onClick={() => openLink(`${getApiDomain()}/auth/dashboard`)}>Panel de administración 😎</button>
            }
        </div>  
        <CookiesModal/>
    </div>                            
}